export default __webpack_public_path__ + "static/media/team-profile-generator.bca35c96.png";